import { React, useEffect } from "react"
import { HashLink as Link } from "react-router-hash-link"
import { Form, Input } from "antd"
import { useDispatch } from "react-redux"
import {
  updateUserDetailsRedux,
  setConnectedWallet,
  setActiveMenu
} from "../../redux/actions"
import swal from "sweetalert"
import axios from "axios"
import { BaseUrl } from "../utils/config"
import "./styles/ecosystem.css"
import Slider from "react-slick"

// Images
import Nlogo from "./images/Eco/Nitro_NLogo.png"
import { Images } from "../../Shared/images"
import { NavLink } from "../menu/header"
import { useNavigate } from "@reach/router"
import { IoTUrl, NcashUrl } from "../../utils/config"
// import { Link, useNavigate, useLocation } from "@reach/router";

// import { Link } from "react-router-dom";

function HomepageNew() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [form] = Form.useForm()
  const submitContactForm = values => {
    const Fobj = {
      first_name: values.fName,
      last_name: values.lName,
      email: values.email,
      comment: values.comment
    }
    if (
      values.fName == null ||
      values.fName == "" ||
      values.lName == null ||
      values.email == null ||
      values.email == "" ||
      values.lName == "" ||
      values.comment == null ||
      values.comment == ""
    ) {
      swal({
        title: "",
        text: "Please enter the Credentials",
        icon: "error"
      })
    } else {
      axios
        .post(`${BaseUrl}/contactus`, Fobj)
        .then(response => {
          if (response) {
            // "Your Federal Account Created Successfully"
            // message.success(`Congratulations  Your Federal Account Created Successfully`,3)
            swal({
              title: "Success!",
              text: "Request submitted successfully, we will review and revert.",
              icon: "success"
            })
            // setTimeout(() => { navigate("/login"); }, 3000)
            form.resetFields()
          } else {
            swal({
              title: "Invalid Credentials",
              text: "Invalid credentials. Please try again.",
              icon: "error"
            })
          }
        })
        .catch(error => {
          if (error?.response?.status === 401) {
            dispatch(updateUserDetailsRedux({}))
            dispatch(setConnectedWallet(""))
            localStorage.clear()
            navigate("/login")
          }
        })
    }
  }

  //Slider Options
  const sliderBanner = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  useEffect(() => {
    document.title = "Nitro's Ecosystem"
    return () => {
      document.title = "Nitro Network"
    }
  }, [])

  return (
    <div className="new-homePage">
      {/* Hero Section */}
      <div className="hero-new">
        <div className="hero-new__image">
          <img src={Images.ncashCircle} alt="Ncash Galaxy" />
        </div>
        <div className="hero-new__text">
          <h1>
            Building real-time utility around NCash through our ambitious
            project
          </h1>
          <p>
            Introducing the world's first web 3.0 project that incentivizes
            smart living!
          </p>

          <div className="ncash-words">
            <p>IoT</p>
            <p>NFT</p>
            <p>NCASH</p>
          </div>
          <a
            href="https://youtu.be/rOlN7hOsASs"
            target="_blank"
            rel="noopener noreferrer"
            className="home-play-btn">
            <img src={Images.playIcon} alt="Play Icon" />
            <span>Play Video</span>
          </a>
          {/* <div className="hero_buttons">
            <a
              href={NcashUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-home green-btn">
              Ncash
            </a>
            <a href="/buy-nfm" className="btn-home green-btn">
              NFT
            </a>
            <a
              href={IoTUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-home green-btn">
              IoT Project
            </a>
          </div> */}
        </div>
      </div>

      <div className="home-carousel">
        <Slider {...sliderBanner}>
          <a href="/buy-nfm">
            <img src={Images.slide1} alt="Banner Markertplace 2" />
          </a>
          <a
            href="https://buy.nitro.network/EMI"
            target="_blank"
            rel="noopener noreferrer">
            <img src={Images.slide2} alt="Banner Markertplace" />
          </a>
          {/* <a
            href="https://www.huobi.com/en-us/exchange/ncash_btc/"
            target="_blank"
            rel="noopener noreferrer">
            <img src={Images.slide3} alt="Banner Markertplace" />
          </a> */}
        </Slider>
      </div>

      {/* <div className="huobi-pair">
        <div className="home-container">
          <div className="huobi-container">
            <div className="huobi__text">
              <h2 className="home-secondary-head color-blue text-left">
                NCash/USDT Pair Is Now Live on Huobi
              </h2>

              <a
                href="https://www.huobi.com/en-us/exchange/ncash_btc/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-home green-btn">
                Buy Ncash
              </a>
            </div>
            <div className="huobi__logo">
              <img src={Images.huobiglobal} alt="Huobi Global Logo" />
            </div>
          </div>
        </div>
      </div> */}
      {/* Our Offerring Section */}
      <section className="our-offering">
        <div className="home-container">
          <h2 className="home-secondary-head">Our Products</h2>

          <div className="offering-cards">
            <a
              href="/buy-nfm"
              className="offer-card transparent-blurBox p-small">
              <div className="offer-image">
                <img src={Images.offer1} alt="Offering Image" />
              </div>
              <p>Buy NFM</p>
            </a>
            <a
              href={IoTUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="offer-card transparent-blurBox p-small">
              <div className="offer-image">
                <img src={Images.offer2} alt="Offering Image" />
              </div>
              <p>IoT Marketplace</p>
            </a>
            <a
              href={NcashUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="offer-card transparent-blurBox p-small">
              <div className="offer-image">
                <img src={Images.offer3} alt="Offering Image" />
              </div>
              <p>NCash Token</p>
            </a>
          </div>
        </div>
      </section>

      {/* Our Tech Stack Section */}
      <section className="our-tech-stack">
        <div className="home-container">
          <h2 className="home-secondary-head">Our Technology Stack</h2>

          <div className="transparent-blurBox p-small">
            <picture>
              <source
                srcSet={Images.techStackMobile}
                media="(max-width:560px)"
              />
              <img src={Images.ourTechStack} alt="Tech Stack Nitro" />
            </picture>
          </div>
        </div>
      </section>

      {/* Our REsours Section */}
      <section className="resources">
        <div className="home-container ">
          <h2 className="home-secondary-head">Resources</h2>

          <div className="rescources-cards">
            <a
              href="https://docsend.com/view/pn69hwzgi8hfqs8m"
              target="_blank"
              rel="noopener noreferrer"
              className="resource-card transparent-blurBox p-small">
              <div className="resource-image">
                <img src={Images.litepaper} alt="REsources Image" />
              </div>
              <p className="text-center">NFM Litepaper</p>
            </a>
            <a
              href="https://docsend.com/view/69wukxyj6vin9bvy"
              target="_blank"
              rel="noopener noreferrer"
              className="resource-card transparent-blurBox p-small">
              <div className="resource-image">
                <img src={Images.whitepaper} alt="REsources Image" />
              </div>
              <p className="text-center">NFM Whitepaper</p>
            </a>
            {/* <a
              href="https://docsend.com/view/69wukxyj6vin9bvy"
              target="_blank"
              rel="noopener noreferrer"
              className="resource-card transparent-blurBox p-small">
              <div className="resource-image">
                <img src={Images.iotWhitepaper} alt="REsources Image" />
              </div>
              <p className="text-center">IoT LitePaper</p>
            </a> */}
            <a
              href="https://docs.nitro.network/"
              target="_blank"
              rel="noopener noreferrer"
              className="resource-card transparent-blurBox p-small">
              <div className="resource-image">
                <img src={Images.nitrodoc} alt="REsources Image" />
              </div>
              <p className="text-center">Documentation</p>
            </a>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section className="our-team">
        <div className="home-container">
          <h2 className="home-secondary-head">Our Team</h2>

          <div className="our-teams-cards">
            <div className="team-card transparent-blurBox p-small">
              <div className="team-image">
                <img src={Images.bot1} alt="Team Image" />
              </div>
              <p>
                <strong>Snoop-Anoop</strong>
              </p>
              <p>CEO</p>
            </div>
            <div className="team-card transparent-blurBox p-small">
              <div className="team-image">
                <img src={Images.bot2} alt="Team Image" />
              </div>
              <p>
                <strong>Kallmediamond</strong>
              </p>
              <p>COO</p>
            </div>
            <div className="team-card transparent-blurBox p-small">
              <div className="team-image">
                <img src={Images.bot3} alt="Team Image" />
              </div>
              <p>
                <strong>Pittibot</strong>
              </p>
              <p>CTO</p>
            </div>
            <div className="team-card transparent-blurBox p-small">
              <div className="team-image">
                <img src={Images.bot4} alt="Team Image" />
              </div>
              <p>
                <strong>Jumpin Jack Thakur</strong>
              </p>
              <p>CPO</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Crypto Partners Section */}
      <section className="our-crypto-partners">
        <div className="home-container">
          <h2 className="home-secondary-head">Our Crypto Partners</h2>

          <div className="our-crypto-cards">
            <div className="crypto-card transparent-blurBox p-small">
              <div className="crypto-image">
                <img src={Images.cointelegraph2} alt="crypto partner Image" />
              </div>
            </div>
            <div className="crypto-card transparent-blurBox p-small">
              <div className="crypto-image">
                <img src={Images.avalance} alt="crypto partner Image" />
              </div>
            </div>
            <div className="crypto-card transparent-blurBox p-small">
              <div className="crypto-image">
                <img src={Images.pangolin} alt="crypto partner Image" />
              </div>
            </div>
            <div className="crypto-card transparent-blurBox p-small">
              <div className="crypto-image">
                <img src={Images.beefy} alt="crypto partner Image" />
              </div>
            </div>
            <div className="crypto-card transparent-blurBox p-small">
              <div className="crypto-image">
                <img src={Images.redlight} alt="crypto partner Image" />
              </div>
            </div>
            <div className="crypto-card transparent-blurBox p-small">
              <div className="crypto-image">
                <img src={Images.techm} alt="crypto partner Image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our IoT  Partners Section */}
      <section className="our-iot-partners">
        <div className="home-container">
          <h2 className="home-secondary-head">Our IoT Partners</h2>

          <div className="iot-cards our-iot">
            <div className="iot-aall">
              <div className="iot-card transparent-blurBox p-small">
                <div className="iot-image">
                  <img src={Images.tektelic} alt="crypto partner Image" />
                </div>
              </div>
              <div className="iot-card transparent-blurBox p-small">
                <div className="iot-image">
                  <img
                    src={Images.milesight}
                    id="investor-image"
                    alt="crypto partner Image"
                  />
                </div>
              </div>
              <div className="iot-card transparent-blurBox p-small">
                <div className="iot-image">
                  <img src={Images.dragino} alt="crypto partner Image" />
                </div>
              </div>
              <div className="iot-card transparent-blurBox p-small">
                <div className="iot-image">
                  <img src={Images.falconx} alt="crypto partner Image" />
                </div>
              </div>
              <div className="iot-card transparent-blurBox p-small">
                <div className="iot-image">
                  <img src={Images.amantya} alt="crypto partner Image" />
                </div>
              </div>
              <div className="iot-card transparent-blurBox p-small">
                <div className="iot-image">
                  <img src={Images.alliot} alt="crypto partner Image" />
                </div>
              </div>
            </div>
            <div className="iot-enthu">
              <div className="iot-card transparent-blurBox p-small grid-2-space">
                <div className="iot-image">
                  <img src={Images.enthu} alt="crypto partner Image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Media  Partners Section */}
      <section className="our-media-partners">
        <div className="home-container">
          <h2 className="home-secondary-head">Our Media Partners</h2>

          <div className="media-cards our-media">
            <div className="media-card transparent-blurBox p-small">
              <div className="media-image">
                <img src={Images.ibc} alt="Media partner Image" />
              </div>
            </div>
            <div className="media-card transparent-blurBox p-small">
              <div className="media-image">
                <img
                  src={Images.investerobserver}
                  id="investor-image"
                  alt="Media partner Image"
                />
              </div>
            </div>
            <div className="media-card transparent-blurBox p-small">
              <div className="media-image">
                <img src={Images.yahooFinance} alt="Media partner Image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- CONTACT US --> */}
      <div className="contact-section transparent-blurBox">
        <div className="contact">
          <div className="image-logo">
            <img
              src={Images.contactSvg}
              alt="Contact Svg Person using laptop"
            />
          </div>
          <div className="form-side">
            <h1>Contact Us</h1>
            <Form
              name="contactForm"
              id="contact_form"
              autoComplete="off"
              form={form}
              onFinish={submitContactForm}>
              {/* <form action=""> */}
              <div className="half-field">
                <div className="form-field">
                  <Form.Item
                    name="fName"
                    rules={[
                      {
                        required: true,
                        message: "First Name is required."
                      }
                    ]}>
                    <Input type="text" id="fname" placeholder="First Name" />
                  </Form.Item>
                  {/* <input type="text" id="fname" placeholder="First Name" /> */}
                </div>
                <div className="form-field">
                  <Form.Item
                    name="lName"
                    rules={[
                      {
                        required: true,
                        message: "Last Name is required."
                      }
                    ]}>
                    <Input type="text" id="lname" placeholder="Last Name" />
                  </Form.Item>
                  {/* <input type="text" id="lname" placeholder="Last Name" /> */}
                </div>
              </div>

              <div className="form-field ">
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Email is required."
                    },
                    {
                      type: "email",
                      message: "The email is not valid."
                    }
                  ]}>
                  <Input type="text" id="email" placeholder="Email Address" />
                </Form.Item>
              </div>

              <div className="form-field margin-0-after-error">
                <Form.Item
                  name="comment"
                  rules={[
                    {
                      required: true,
                      message: "Comment is required."
                    }
                  ]}>
                  <textarea
                    id="comment"
                    cols="30"
                    rows="5"
                    placeholder="Comment"></textarea>
                </Form.Item>
              </div>
              <div className="submit-btn-eco">
                <button
                  type="submit"
                  className="learn-more-btn w-100 uppercase"
                  style={{
                    border: "none"
                  }}>
                  Send Message
                </button>
                {/* <a href="#" className="learn-more-btn w-100 uppercase">
                  Send MEssage
                </a> */}
              </div>
              {/* </form> */}
            </Form>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  )
}

export default HomepageNew
